import { useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import { dispatchListingRemoved } from "../events/listingRemoved";
import { displayListingUnsavedNotification } from "../helpers";

const STOP_LISTING_JOURNEY = gql`
  mutation stop_listing_journey($listing_journey_id: ID!) {
    stop_listing_journey(listing_journey_id: $listing_journey_id)
  }
`;

export const useStopListingJourney = (
  { listingId, listingJourneyId, listingType },
  callback
) => {
  const [stopListingJourneyMutation] = useMutation(STOP_LISTING_JOURNEY, {
    onCompleted: () => {
      dispatchListingRemoved({ listingId, listingType });
      displayListingUnsavedNotification({ listingId, listingType });

      if (window.dataLayer) {
        window.dataLayer.push({
          event: "custom_event",
          event_category: "unsave",
          event_action: listingType,
          event_label: listingId
        });
      }

      if (callback) callback();
    }
  });

  const stopListingJourney = () =>
    stopListingJourneyMutation({
      variables: { listing_journey_id: listingJourneyId }
    });

  return [stopListingJourney];
};
